export let subscribers = []

/**
 * call this to open the modal from anywhere. No context or hooks needed
 * @param {{page: ProfileSettingsPage}} defaultState
 */
export function openProfileSettingsModal(defaultState = true) {
    subscribers.map((fn) => fn(defaultState))
}
